import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../../components/Button';
import Search from '../../../components/inputs/Search';
import { openEditNoticeDialog } from '../store';
import PropTypes from 'prop-types';

const NoticeBoardFilters = ({ canCreate }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(openEditNoticeDialog());
  }, [dispatch]);

  return (
    <div className="cluster-4 items-center">
      <Search className="flex-1" />
      {canCreate && (
        <Button
          data-testid="button-add-variable"
          type="primary"
          onClick={onAdd}
        >
          {t('addNotice')}
        </Button>
      )}
    </div>
  );
};

NoticeBoardFilters.propTypes = {
  canCreate: PropTypes.bool,
};

NoticeBoardFilters.defaultProps = {
  canCreate: false,
};

export default NoticeBoardFilters;
